
import React, { Component } from 'react'
import NoticeFilter from './NoticeFilter'

class NoticeItem extends Component {
  render () {
    const dayFilter = this.props.list.filter(data => data.day === this.props.dayList)

    const dayNoticeList = dayFilter.map(
      (item, i) => (<NoticeFilter item={item} key={i} clickLink={this.props.clickLink} deleteNotice={this.props.deleteNotice} userGroup={this.props.userGroup} />)
    )

    const dayList = this.props.dayList.slice(6, 20)

    const newDate = new Date()
    const newYear = newDate.getFullYear()
    const newMonth = newDate.getMonth() + 1
    const newDay = newDate.getDate()
    const week = new Array('일', '월', '화', '수', '목', '금', '토')
    const newDayName = week[newDate.getDay()]
    const newDayName2 = week[newDate.getDay() - 1]

    const today = newYear + '년 ' + newMonth + '월 ' + newDay + '일 ' + '(' + newDayName + ')'
    const yesterday = newYear + '년 ' + newMonth + '월 ' + (newDay - 1) + '일 ' + '(' + newDayName2 + ')'
    let dayClass = ''

    if (this.props.dayList === today) {
      dayClass = 'today_list'
    } else if (this.props.dayList === yesterday) {
      dayClass = 'yesterday_list'
    }

    return (
      <div className={'notice_list ' + dayClass}>
        <ul className="day_wrap">
          <li className="day_circle"><div></div></li>
          {this.props.dayList === today &&
            <li className="day_label">오늘</li>
          }
          {this.props.dayList === yesterday &&
            <li className="day_label">어제</li>
          }
          <li className="day_title">{dayList}</li>
        </ul>
        <div>{dayNoticeList}</div>
      </div>
    )
  }
}

export default NoticeItem



// WEBPACK FOOTER //
// ./Src/Components/Notice/NoticeItem.js